export const FA_SELECTOR = '.fas, .far, .fal';
